import { defineComponent as _defineComponent } from 'vue'
import AddressVerificationDocument from "@/views/pages/profile/AddressVerificationDocument.vue";
import {computed, onMounted, ref} from "vue";
import HorizontalFormGroup from "@/components/forms/horizontal/HorizontalFormGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressVerificationDocuments',
  props: {
  maxDocuments: {
    type: Number,
    default: 3
  },
  disabled: {
    type: Boolean,
    default: false
  },
  model: {
    type: Object,
    default: null
  },
  modelAttributePrefix: {
    type: String,
    default: 'addressDocument'
  }
},
  emits: ['input'],
  setup(__props, { expose, emit: emits }) {

const props = __props;




const documentsCount = ref(1);
const documents = ref([]);

onMounted(() => {
  refreshDocumentsList()
})

const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0,
      v = c === 'x'
        ? r
        : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const documentRefs = ref([])

const refreshDocumentsList = () => {
  const visibleCount = documents.value.filter((document) => document.visible).length;
  const countToAdd = documentsCount.value - visibleCount;
  for (let i = 0; i < countToAdd; i++) {
    documents.value.push({
      visible: true,
      id: uuidv4(),
    });
  }

  onDocumentChanged();
}

const visibleDocuments = computed(() => {
  return documents.value.filter((document) => document.visible);
})

const addDocument = () => {
  if (documentsCount.value < props.maxDocuments) {
    documentsCount.value++;
    refreshDocumentsList();
  }
}

const setItemRef = (el) => {
  if (el) {
    documentRefs.value.push(el)
  }
}

const removeDocument = (id) => {

  // console.log('refs', documentRefs);
  // documents[index].visible = false;
  // console.log('remove ', documents.value)
  const idx = documents.value.findIndex((document) => document.id === id);
  documents.value[idx].visible = false;
  documentRefs.value[idx].resetDocument();
  if (documentsCount.value > 1)
    documentsCount.value--;
  refreshDocumentsList();
}

const getDocuments = () => {
  let result = [];
  documents.value.forEach((document, index) => {
    if (document.visible && documentRefs.value[index]?.documentInfo)
    {
      result = [...result, ...documentRefs.value[index].documentInfo];
    }
  })
  return result;
}

const visibleDocumentRefs = computed(() => {
  const result = [];
  documents.value.forEach((document, index) => {
    if (document.visible && documentRefs.value[index])
    {
      result.push(documentRefs.value[index]);
    }
  })
  return result;
})

const busy = computed(() => {
  return visibleDocumentRefs.value.some((document) => document.busy);
})

const reset = () => {
  documentsCount.value = 1;
  documents.value.forEach((document, index) => {
    document.visible = false;
    documentRefs.value[index].resetDocument();
  })
  refreshDocumentsList();
}



const onDocumentChanged = () => {
  // console.log('document changed', value);
  const docs = getDocuments();
  // console.log('documents total', docs);
  emits('input', docs);
}

expose({getDocuments, reset, busy})

return { __sfc: true,props, documentsCount, documents, uuidv4, documentRefs, refreshDocumentsList, visibleDocuments, addDocument, setItemRef, removeDocument, getDocuments, visibleDocumentRefs, busy, reset, emits, onDocumentChanged, AddressVerificationDocument, HorizontalFormGroup }
}

})